import { action } from 'satcheljs';
import ReadWriteRecipientWellViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientWellViewState';
import { RecipientData } from 'owa-readwrite-recipient-well/lib/actions/addReadWriteRecipients';

const onRecipientsChanged = action(
    'onRecipientsChanged',
    (
        recipientWellRecipients: ReadWriteRecipientWellViewState,
        recipientData?: RecipientData[]
    ) => ({
        recipientWellRecipients,
        recipientData,
    })
);

export default onRecipientsChanged;
